"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateQueryParameters = void 0;
/**
 * Updates current url query parameters without reloading page in browser
 */
const updateQueryParameters = newQueryParameters => {
  const newUrl = new URL(window.location.toString());
  newUrl.search = newQueryParameters.toString();
  window.history.replaceState('', document.title, newUrl);
};
exports.updateQueryParameters = updateQueryParameters;
//# sourceMappingURL=updateQueryParameters.js.map